import {createTheme} from '@mui/material/styles';

const theme = createTheme({
    palette: {
        background: {
            default: '#fbfbfb',
        },
        primary: {
            main: '#1d2a41',
        },
        secondary: {
            main: '#dc004e',
        },
    },
    components: {
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: '40px',
                    padding: '8px',
                    border: '1px solid rgba(224, 224, 224, 1)',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '16px',
                    textTransform: 'none',
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '16px',
                        '& fieldset': {
                            borderColor: 'rgba(224, 224, 224, 1)',
                        },
                        '&:hover fieldset': {
                            borderColor: 'rgba(224, 224, 224, 1)',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: 'rgba(224, 224, 224, 1)',
                        },
                    },
                    '& .MuiInputBase-input::placeholder': {
                        color: 'rgba(224, 224, 224, 1)',
                        opacity: 1,
                    },
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    borderRadius: '16px',
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(224, 224, 224, 1)',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(224, 224, 224, 1)',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(224, 224, 224, 1)',
                    },
                },
            },
        },
    },
});

export default theme;
